import normalizeProjectPath from "../../../gd/utils/normalize-project-path"

export default function mapProject(companyId: string, projectName: string, projectPathSeparator?:string) {

    // NEW (path i.e. FOLDER > SUBFOLDER

    projectName = normalizeProjectPath(projectName, projectPathSeparator)

    const project = gd.session.projects.findByFullPath(projectName)
    if (project) {
        return project.id
    }

    return null
}
